
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as andra_45adressO6lKXtJ5Rwfw37_LAA3pK_l7hYxPoMKPt9BSQbXGm_gMeta } from "/opt/build/repo/apps/act/pages/id/medlemskort/andra-adress.vue?macro=true";
import { default as andra_45gavamjk0plR6HlJJsoBE6_O8kC1J1HA68CWCraDPdf14Y10Meta } from "/opt/build/repo/apps/act/pages/id/medlemskort/andra-gava.vue?macro=true";
import { default as byt_45kontouppgifterlElY9s4XakCyntOYpa2VC_jy8ZGXKrdBQjJkWXBVa0AMeta } from "/opt/build/repo/apps/act/pages/id/medlemskort/byt-kontouppgifter.vue?macro=true";
import { default as digital_45tidningJBD9_5R7h7E2uAnw7JC4y58Ex14Q7EwcGfB_RJAoehkMeta } from "/opt/build/repo/apps/act/pages/id/medlemskort/digital-tidning.vue?macro=true";
import { default as _91_46_46_46slug_93AK20AA3QBj93dRSCGSPxjpMKBJU0ryw5rbkfEaY32TQMeta } from "/opt/build/repo/apps/act/pages/1882/company-monthly/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_933_JPaSzmXjcSsKhvbcVQYRHx0UBIzrK6kELRRMHOEUcMeta } from "/opt/build/repo/apps/act/pages/1882/company/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93_8TmiE84gobwRIA80gAeP1oxOtLq0PkLneRJOMd6V4QMeta } from "/opt/build/repo/apps/act/pages/1882/donation/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93sWK4AC6vqfNNLT3f4FuA_LHBx_wdX2j_gAcrndFD4i8Meta } from "/opt/build/repo/apps/act/pages/1882/monthly/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_931TrPyLfPorSBsPfdo_9LATOspNRKQxew3s24Rj0wAdUMeta } from "/opt/build/repo/apps/act/pages/arsmedlem/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_933ANgbfalWJhksTkusvzM4yNJbjSL1gaDCMHBsfVF_F0Meta } from "/opt/build/repo/apps/act/pages/foretagsgava/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93wpGkM9ZQBHyUgdKojF_U8Gofh5tQfMYieYGoEZThs2sMeta } from "/opt/build/repo/apps/act/pages/fornya/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93nzKcj59gM0lZWP0VlCz86oNppgkaqbi0Ly_W3_HiaZgMeta } from "/opt/build/repo/apps/act/pages/gava/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93MBkEAArirmoqhLSbPmwNMRkUfeaYNm6XFW_AIW4chowMeta } from "/opt/build/repo/apps/act/pages/gavobevis/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93CoLBSfx_3r0nid2Ue4toZsY2DrcHAWKEscLw__zwe_8Meta } from "/opt/build/repo/apps/act/pages/ge-medlemskap/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_936o80XyXKHFmoczt1qrSaQgBbSPr_nRh3Ywa0dgOr6gMMeta } from "/opt/build/repo/apps/act/pages/manadsgivare/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93gDh2t9WOwXR_HSdOeUGCvoi4M5Ka3iORljgXjYjodgUMeta } from "/opt/build/repo/apps/act/pages/medgivande/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93y8XklOnvV4mFgQsL6meSL49a_78pS1fB4ie9VIQ4ZrwMeta } from "/opt/build/repo/apps/act/pages/minnesgava/[...slug].vue?macro=true";
export default [
  {
    name: "id-medlemskort-andra-adress",
    path: "/id/medlemskort/andra-adress",
    meta: { ...(andra_45adressO6lKXtJ5Rwfw37_LAA3pK_l7hYxPoMKPt9BSQbXGm_gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/build/repo/apps/act/pages/id/medlemskort/andra-adress.vue")
  },
  {
    name: "id-medlemskort-andra-gava",
    path: "/id/medlemskort/andra-gava",
    meta: { ...(andra_45gavamjk0plR6HlJJsoBE6_O8kC1J1HA68CWCraDPdf14Y10Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/build/repo/apps/act/pages/id/medlemskort/andra-gava.vue")
  },
  {
    name: "id-medlemskort-byt-kontouppgifter",
    path: "/id/medlemskort/byt-kontouppgifter",
    meta: { ...(byt_45kontouppgifterlElY9s4XakCyntOYpa2VC_jy8ZGXKrdBQjJkWXBVa0AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/build/repo/apps/act/pages/id/medlemskort/byt-kontouppgifter.vue")
  },
  {
    name: "id-medlemskort-digital-tidning",
    path: "/id/medlemskort/digital-tidning",
    meta: { ...(digital_45tidningJBD9_5R7h7E2uAnw7JC4y58Ex14Q7EwcGfB_RJAoehkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/build/repo/apps/act/pages/id/medlemskort/digital-tidning.vue")
  },
  {
    name: "1882-company-monthly-slug",
    path: "/1882/company-monthly/:slug(.*)*",
    meta: _91_46_46_46slug_93AK20AA3QBj93dRSCGSPxjpMKBJU0ryw5rbkfEaY32TQMeta || {},
    alias: ["/company-monthly","/company-monthly/:slug(.*)*"],
    component: () => import("/opt/build/repo/apps/act/pages/1882/company-monthly/[...slug].vue")
  },
  {
    name: "1882-company-slug",
    path: "/1882/company/:slug(.*)*",
    meta: _91_46_46_46slug_933_JPaSzmXjcSsKhvbcVQYRHx0UBIzrK6kELRRMHOEUcMeta || {},
    alias: ["/company","/company/:slug(.*)*"],
    component: () => import("/opt/build/repo/apps/act/pages/1882/company/[...slug].vue")
  },
  {
    name: "1882-donation-slug",
    path: "/1882/donation/:slug(.*)*",
    meta: _91_46_46_46slug_93_8TmiE84gobwRIA80gAeP1oxOtLq0PkLneRJOMd6V4QMeta || {},
    alias: ["/donation","/donation/:slug(.*)*"],
    component: () => import("/opt/build/repo/apps/act/pages/1882/donation/[...slug].vue")
  },
  {
    name: "1882-monthly-slug",
    path: "/1882/monthly/:slug(.*)*",
    meta: _91_46_46_46slug_93sWK4AC6vqfNNLT3f4FuA_LHBx_wdX2j_gAcrndFD4i8Meta || {},
    alias: ["/monthly","/monthly/:slug(.*)*"],
    component: () => import("/opt/build/repo/apps/act/pages/1882/monthly/[...slug].vue")
  },
  {
    name: "demo-billecta-accounts",
    path: "/demo/billecta-accounts",
    component: () => import("/opt/build/repo/apps/act/pages/demo/billecta-accounts.vue")
  },
  {
    name: "demo-billecta-accounts-v2",
    path: "/demo/billecta-accounts-v2",
    component: () => import("/opt/build/repo/apps/act/pages/demo/billecta-accounts-v2.vue")
  },
  {
    name: "demo-billecta-id",
    path: "/demo/billecta-id",
    component: () => import("/opt/build/repo/apps/act/pages/demo/billecta-id.vue")
  },
  {
    name: "demo-billecta-sign",
    path: "/demo/billecta-sign",
    component: () => import("/opt/build/repo/apps/act/pages/demo/billecta-sign.vue")
  },
  {
    name: "demo-billecta-sign-v2",
    path: "/demo/billecta-sign-v2",
    component: () => import("/opt/build/repo/apps/act/pages/demo/billecta-sign-v2.vue")
  },
  {
    name: "demo-delivery-datepicker",
    path: "/demo/delivery-datepicker",
    component: () => import("/opt/build/repo/apps/act/pages/demo/delivery-datepicker.vue")
  },
  {
    name: "demo-radio-buttons",
    path: "/demo/radio-buttons",
    component: () => import("/opt/build/repo/apps/act/pages/demo/radio-buttons.vue")
  },
  {
    name: "demo-reform-test",
    path: "/demo/reform-test",
    component: () => import("/opt/build/repo/apps/act/pages/demo/reform-test.vue")
  },
  {
    name: "demo-rive",
    path: "/demo/rive",
    component: () => import("/opt/build/repo/apps/act/pages/demo/rive.vue")
  },
  {
    name: "demo-scrollable",
    path: "/demo/scrollable",
    component: () => import("/opt/build/repo/apps/act/pages/demo/scrollable.vue")
  },
  {
    name: "demo-swish",
    path: "/demo/swish",
    component: () => import("/opt/build/repo/apps/act/pages/demo/swish.vue")
  },
  {
    name: "demo-swish-mvp",
    path: "/demo/swish-mvp",
    component: () => import("/opt/build/repo/apps/act/pages/demo/swish-mvp.vue")
  },
  {
    name: "id-medlemskort",
    path: "/id/medlemskort",
    component: () => import("/opt/build/repo/apps/act/pages/id/medlemskort/index.vue")
  },
  {
    name: "arsmedlem-slug",
    path: "/arsmedlem/:slug(.*)*",
    meta: _91_46_46_46slug_931TrPyLfPorSBsPfdo_9LATOspNRKQxew3s24Rj0wAdUMeta || {},
    component: () => import("/opt/build/repo/apps/act/pages/arsmedlem/[...slug].vue")
  },
  {
    name: "foretagsgava-slug",
    path: "/foretagsgava/:slug(.*)*",
    meta: _91_46_46_46slug_933ANgbfalWJhksTkusvzM4yNJbjSL1gaDCMHBsfVF_F0Meta || {},
    component: () => import("/opt/build/repo/apps/act/pages/foretagsgava/[...slug].vue")
  },
  {
    name: "fornya-slug",
    path: "/fornya/:slug(.*)*",
    meta: _91_46_46_46slug_93wpGkM9ZQBHyUgdKojF_U8Gofh5tQfMYieYGoEZThs2sMeta || {},
    component: () => import("/opt/build/repo/apps/act/pages/fornya/[...slug].vue")
  },
  {
    name: "gava-slug",
    path: "/gava/:slug(.*)*",
    meta: _91_46_46_46slug_93nzKcj59gM0lZWP0VlCz86oNppgkaqbi0Ly_W3_HiaZgMeta || {},
    component: () => import("/opt/build/repo/apps/act/pages/gava/[...slug].vue")
  },
  {
    name: "gavobevis-slug",
    path: "/gavobevis/:slug(.*)*",
    meta: _91_46_46_46slug_93MBkEAArirmoqhLSbPmwNMRkUfeaYNm6XFW_AIW4chowMeta || {},
    component: () => import("/opt/build/repo/apps/act/pages/gavobevis/[...slug].vue")
  },
  {
    name: "ge-medlemskap-slug",
    path: "/ge-medlemskap/:slug(.*)*",
    meta: _91_46_46_46slug_93CoLBSfx_3r0nid2Ue4toZsY2DrcHAWKEscLw__zwe_8Meta || {},
    component: () => import("/opt/build/repo/apps/act/pages/ge-medlemskap/[...slug].vue")
  },
  {
    name: "manadsgivare-slug",
    path: "/manadsgivare/:slug(.*)*",
    meta: _91_46_46_46slug_936o80XyXKHFmoczt1qrSaQgBbSPr_nRh3Ywa0dgOr6gMMeta || {},
    component: () => import("/opt/build/repo/apps/act/pages/manadsgivare/[...slug].vue")
  },
  {
    name: "medgivande-slug",
    path: "/medgivande/:slug(.*)*",
    meta: _91_46_46_46slug_93gDh2t9WOwXR_HSdOeUGCvoi4M5Ka3iORljgXjYjodgUMeta || {},
    component: () => import("/opt/build/repo/apps/act/pages/medgivande/[...slug].vue")
  },
  {
    name: "minnesgava-slug",
    path: "/minnesgava/:slug(.*)*",
    meta: _91_46_46_46slug_93y8XklOnvV4mFgQsL6meSL49a_78pS1fB4ie9VIQ4ZrwMeta || {},
    component: () => import("/opt/build/repo/apps/act/pages/minnesgava/[...slug].vue")
  },
  {
    name: "gracias",
    path: "/gracias",
    component: () => import("/opt/build/repo/apps/act/pages/gracias.vue")
  },
  {
    name: "progress",
    path: "/progress",
    component: () => import("/opt/build/repo/apps/act/pages/progress.vue")
  },
  {
    name: "reject",
    path: "/reject",
    component: () => import("/opt/build/repo/apps/act/pages/reject.vue")
  },
  {
    name: "result",
    path: "/result",
    component: () => import("/opt/build/repo/apps/act/pages/result.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/opt/build/repo/apps/act/pages/success.vue")
  },
  {
    name: "tack",
    path: "/tack",
    component: () => import("/opt/build/repo/apps/act/pages/tack.vue")
  },
  {
    name: "thank-you",
    path: "/thank-you",
    component: () => import("/opt/build/repo/apps/act/pages/thank-you.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/apps/act/pages/index.vue")
  }
]